import { createBrowserRouter, Outlet } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { AuthWrapper } from './AuthWrapper';
import { AppLayout } from './components/AppLayout';
import { RoleGuard } from './components/RoleGuard';
import { routeConfigs } from './config/routes';
import { PublicWrapper } from './PublicWrapper';
import { Login } from './views/Login';
import { Page404 } from './views/Page404';

export const router = createBrowserRouter([
	{
		element: (
			<PublicWrapper>
				<Outlet />
			</PublicWrapper>
		),
		children: [
			{
				path: '/login',
				element: <Login />,
			},
		],
	},
	{
		element: (
			<AuthWrapper>
				<QueryParamProvider adapter={ReactRouter6Adapter}>
					<Outlet />
				</QueryParamProvider>
			</AuthWrapper>
		),
		children: [
			{
				element: <AppLayout />,
				children: [
					...routeConfigs.map(route => ({
						path: route.path,
						element: (
							<RoleGuard allowedRoles={route.allowedRoles}>
								<route.element />
							</RoleGuard>
						),
					})),
					{ path: '*', element: <Page404 /> },
				],
			},
		],
	},
]);
